module.exports = __webpack_public_path__ + "img/shopVersion.4bb9d176.jpg";